var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-container',[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('br'),_c('br'),_vm._v(" "),_c('video',{staticClass:"b11Vid",attrs:{"controls":""}},[_c('source',{attrs:{"src":require("../../assets/B11.mp4"),"type":"video/mp4"}}),_vm._v("\n                    Your browser does not support the video tag.\n                ")])])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-170156ca","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/HomeComp/B11.vue
// module id = null
// module chunks = 